import { USERS_URL } from '../constants';
import { apiSlice } from './apiSlice';

const activityTag = (customerId) => [{ type: 'CustomerActivity', id: customerId }];
export const customerActivitiesApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['CustomerActivity'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCustomerActivities: builder.query({
        query: ({ customerId, page = 1 }) => ({ url: `${USERS_URL}/${customerId}/activities`, params: { page } }),
        providesTags: (_result, _error, { customerId }) => activityTag(customerId),
        keepUnusedDataFor: 5,
      }),
      addCustomerActivity: builder.mutation({
        query: ({ customerId, ...body }) => ({ url: `${USERS_URL}/${customerId}/activities`, method: 'POST', body }),
        invalidatesTags: (_result, _error, { customerId }) => activityTag(customerId),
      }),
      updateCustomerActivity: builder.mutation({
        query: ({ customerId, activityId, ...body }) => ({ url: `${USERS_URL}/${customerId}/activities/${activityId}`, method: 'PUT', body }),
        invalidatesTags: (_result, _error, { customerId }) => activityTag(customerId),
      }),
      deleteCustomerActivity: builder.mutation({
        query: ({ customerId, activityId }) => ({ url: `${USERS_URL}/${customerId}/activities/${activityId}`, method: 'DELETE' }),
        invalidatesTags: (_result, _error, { customerId }) => activityTag(customerId),
      }),
    }),
  });

export const { useGetCustomerActivitiesQuery, useAddCustomerActivityMutation,
  useUpdateCustomerActivityMutation, useDeleteCustomerActivityMutation } = customerActivitiesApiSlice;
